import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

// react-snap prerender support: when the build was prerendered, the root
// already contains server-rendered markup and we must hydrate it. In
// development or when no prerender exists, use createRoot for a fresh
// client-side render. This dual-path keeps the SPA behaviour intact for
// users while letting social crawlers (Facebook, X, LinkedIn) and tools
// like metatags.io see per-route metadata in the raw HTML.
const rootEl = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (rootEl.hasChildNodes()) {
  hydrateRoot(rootEl, app);
} else {
  createRoot(rootEl).render(app);
}
